export const PRICING_HUB_HOME_PATH = '/' as const
export const PRICING_HUB_INSPECTOR_PATH = '/inspector' as const

export type PricingHubLaunchInput = {
  baseUrl: unknown
  path: string
  query?: Record<string, string | undefined>
  token: unknown
  accountId: unknown
  role: unknown
}

const clean = (value: unknown): string => String(value ?? '').trim()

// Builds the Pricing Hub launch URL using the same application-launch contract as
// JAMS "Open Dashboard": path query first, then token, juid, role and redirectionDo.
// Returns undefined (never throws) when any launch input is missing.
export const buildPricingHubLaunchUrl = ({
  baseUrl,
  path,
  query,
  token,
  accountId,
  role,
}: PricingHubLaunchInput): string | undefined => {
  const base = clean(baseUrl).replace(/\/+$/, '')
  const sessionToken = clean(token)
  const juid = clean(accountId)
  const userRole = clean(role)

  if (!base || !sessionToken || !juid || !userRole) return undefined
  if (typeof path !== 'string' || !path.startsWith('/')) return undefined

  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(query ?? {})) {
    const cleaned = clean(value)
    if (cleaned) params.append(key, cleaned)
  }
  params.append('token', sessionToken)
  params.append('juid', juid)
  params.append('role', userRole)
  params.append('redirectionDo', 'true')

  return `${base}${path}?${params.toString()}`
}
